let widget = null;
let wanted = false; // 위젯이 떠 있어야 하는 상태인지 (마지막 요청 기준)
let loading = false; // SDK 스크립트를 내려받는 중인지

const initWidget = () => {
  widget = window.MSAPChat.init({
    applicationKey: process.env.VUE_APP_MSAP_CHAT_KEY || '__MSAP_CHAT_KEY__',
  });

  // 처음 방문한 사용자에게만 열기
  const hasVisited = localStorage.getItem('msap-chat-visited');
  if (!hasVisited) {
    widget.open();
    localStorage.setItem('msap-chat-visited', 'true');
  }
};

/**
 * MSAP Chat SDK 로드 및 초기화
 */
export function loadMSAPChat() {
  wanted = true;
  if (widget || loading) return;

  // SDK가 이미 로드되어 있으면 스크립트를 다시 추가하지 않는다
  if (window.MSAPChat) return initWidget();

  loading = true;
  const script = document.createElement('script');
  script.id = 'msap-chat-sdk';
  script.src = 'https://sdk.turacocloud.com/msap-ai-chat.min.js';
  script.onload = () => {
    loading = false;
    // 스크립트를 내려받는 동안 제거 요청이 들어온 경우(인쇄 화면, 로그인 화면 등) 위젯을 만들지 않는다
    if (!wanted) return;
    initWidget();
  };
  script.onerror = () => {
    loading = false;
  };
  document.body.appendChild(script);
}

/**
 * MSAP Chat 위젯 제거
 */
export function removeMSAPChat() {
  wanted = false;
  if (widget) {
    widget.destroy();
    widget = null;
  }
}
